import { render, staticRenderFns } from "./StackedBarChartCard.vue?vue&type=template&id=f9ba89ea&scoped=true"
import script from "./StackedBarChartCard.vue?vue&type=script&lang=js"
export * from "./StackedBarChartCard.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChartCard.vue?vue&type=style&index=0&id=f9ba89ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ba89ea",
  null
  
)

export default component.exports